import { createFileRoute } from "@tanstack/react-router";
import { buildRouteHead } from "@/lib/seo/routeHead";
import ThankYou from "@/pages/ThankYou";
const ThankYouRoute = () => <ThankYou variant="contact" />;

export const Route = createFileRoute("/es/gracias/contacto")({
  head: () => buildRouteHead("/es/gracias/contacto"),
  component: ThankYouRoute,
});

